export const POLYNOMIAL_TRACKING_CODE =
	'0x706f6c796e6f6d69616c00000000000000000000000000000000000000000000';
export const PRICE_IMPACT_DELTA = '50000000000000000';

export const LARGE_POSITIVE_INT = '2596148429267413810000000000000000';
export const LARGE_NEGATIVE_INT = '-2596148429267413810000000000000000';
export const SWAP_SLIPPAGE = '500000000000000000';
export const POLYNOMIAL_FEE = '0.001';
export const FEE_RECIPIENT = '0x7cb6bf3e7395965b2162a7c2e6876720c20012d6';
export const MIN_ETH_BALANCE = '0.005';
export const MAX_PRIORITY_FEE_PER_GAS = '1000000'